import { FonctionResource } from "types/service.type";
import { CrudService } from "./crudService";

const crud = new CrudService<FonctionResource, FonctionResource>("fonctions");

export const fonctionService = {
  ...crud,
};
